(() => {
 const script=document.currentScript;
 const cartUrl=script?.dataset.cartUrl;
 const key='unity:continue-shopping';
 const safeProductUrl=value=>{
  try{const url=new URL(value,location.origin);return url.origin===location.origin&&url.pathname.includes('/products/')?url.href:null;}catch{return null;}
 };
 document.addEventListener('baseline:cart:afteradditem',()=>{
  if(!cartUrl)return;
  const productUrl=safeProductUrl(location.href);
  if(productUrl){try{sessionStorage.setItem(key,productUrl);}catch{}}
  if(matchMedia('(max-width: 1023px)').matches)location.assign(cartUrl);
 });
 const init=()=>{
  let previous;
  try{previous=safeProductUrl(sessionStorage.getItem(key));}catch{}
  previous=previous||safeProductUrl(document.referrer);
  if(previous)document.querySelectorAll('[data-unity-continue-shopping]').forEach(link=>{link.href=previous;});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 const footer=document.getElementById('main-cart-footer');
 if(footer)new MutationObserver(init).observe(footer,{childList:true,subtree:true});
})();